import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { CallState } from '@lcs/shared/api';
import { EditPresenceCredentialsData } from '../models/edit-presence-credential-data';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ndt-edit-presence-credentials-view',
    styleUrls: ['./edit-presence-credentials-view.component.scss'],
    templateUrl: './edit-presence-credentials-view.component.html',
    standalone: false
})
export class EditPresenceCredentialsViewComponent {
   @Input() callState: CallState;

   @Output() formSubmitted = new EventEmitter<EditPresenceCredentialsData>();
   @Output() formCanceled = new EventEmitter<void>();

   @Input() form: UntypedFormGroup;

   showPassword = false;

   onCloseClick(): void {
      this.formCanceled.emit();
   }

   onCreate(): void {
      if (this.form.valid) {
         this.formSubmitted.emit();
      }
   }
}
